import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=760dd6c2"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"
import style0 from "./Download.vue?vue&type=style&index=0&id=760dd6c2&lang=scss&spcped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('760dd6c2')) {
      api.createRecord('760dd6c2', component.options)
    } else {
      api.reload('760dd6c2', component.options)
    }
    module.hot.accept("./Download.vue?vue&type=template&id=760dd6c2", function () {
      api.rerender('760dd6c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Download.vue"
export default component.exports